// extracted by mini-css-extract-plugin
module.exports = {"success":"Success_success__gQA4S"};